'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'clsx';

import Img from 'components/ui/Img';
import Text from 'components/ui/Text';

import EyebrowRibbon from '../EyebrowRibbon';

import styles from './Intro.module.scss';

const cards = [
    {
        id: 'morning',
        eyebrow: 'Legacy',
        title: 'The Morning Star',
        image: {
            url: 'https://images.ctfassets.net/j8tkpy1gjhi5/3xLLKCbxqPKTb214tFdJJ3/f859c5a822199565fbb8bae8858dcf51/tales-boat-m.png',
            width: 354,
            height: 272,
            description: 'an old sail boat',
        },
        imageLarge: {
            url: 'https://images.ctfassets.net/j8tkpy1gjhi5/7aedCwgBASqhkm4uf5FccZ/9f9cd4bb557b56dc0db392bb58dbcc7b/tales-boat-d.png',
            width: 816,
            height: 724,
            description: 'an old sail boat',
        },
        color: 'morning-blue',
    },
    {
        id: 'journey',
        eyebrow: 'History',
        title: 'Our Journey',
        image: {
            url: 'https://images.ctfassets.net/j8tkpy1gjhi5/bualsn6gpgFjtTfQKawCF/56a54e26302bfab446324782faf000ea/image_27.png',
            width: 396,
            height: 272,
            description: 'Tillamook bolt',
        },
        imageLarge: {
            url: 'https://images.ctfassets.net/j8tkpy1gjhi5/2vWnbHHlQJOmG7ErYXbOcb/71bc4c6abdc7e4f2523a44d5e3cdd986/image.png',
            width: 816,
            height: 760,
            description: 'Tillamook bolt',
        },
        color: 'blue',
    },
    {
        id: 'stories',
        eyebrow: 'Community',
        title: 'Your Stories',
        image: {
            url: 'https://images.ctfassets.net/j8tkpy1gjhi5/3TLL6ByI87lsjDyCmGUpeF/7a393deca6b9841e59d5c3f26279353c/tales-envelope-m.png',
            width: 386,
            height: 232,
            description: 'envelope with morning star logo',
        },
        imageLarge: {
            url: 'https://images.ctfassets.net/j8tkpy1gjhi5/4ob9tdZAE4A53VjA9fQP4u/15721797642b753f7df34bff75fed8c4/tales-envelope-d.png',
            width: 816,
            height: 726,
            description: 'envelope with morning star logo',
        },
        color: 'green',
    },
];

const Intro = () => {
    const handleCardClick = id => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section className={styles.root}>
            <div className={styles.inner}>
                <div className={styles.header}>
                    <Text
                        className={styles.copy}
                        baseTheme="bodyMedium"
                        themes={{
                            medium: 'bodyLarge',
                            large: 'bodyXLarge',
                        }}
                    >
                        Our dairy comes from some pretty incredible beginnings.
                        Discover the story behind Tillamook County Creamery
                        Association.
                    </Text>
                </div>
                <ul className={styles.cards}>
                    {cards.map((card, index) => (
                        <li
                            key={index}
                            className={styles.card}
                            style={{
                                backgroundColor: `var(--tales-color-${card.color})`,
                            }}
                        >
                            <button
                                className={styles.cardInner}
                                onClick={() => {
                                    handleCardClick(card.id);
                                }}
                            >
                                <span className={styles.lockup}>
                                    <EyebrowRibbon>
                                        {card.eyebrow}
                                    </EyebrowRibbon>
                                    <Text
                                        className={styles.title}
                                        baseTheme="displayXXSmall"
                                    >
                                        {card.title}
                                    </Text>
                                </span>
                                <Img
                                    className={cx(
                                        styles.image,
                                        styles[card.id]
                                    )}
                                    src={card.image.url}
                                    width={card.image?.width}
                                    height={card.image?.height}
                                    alt={card.image.description}
                                    customSources={[
                                        {
                                            breakpoint: 768,
                                            src: card.imageLarge.url,
                                            imageWidth: 1280,
                                        },
                                        {
                                            src: card.image.url,
                                            imageWidth: 500,
                                        },
                                    ]}
                                />
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default Intro;
